<template lang="pug">
el-collapse#empresa-bloco-inserir-contrato-originacao-manualmente
    el-collapse-item(name='cadastroManual')
        h2.cadastro-contrato-originacao__subtitulo(slot='title') {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.titulo') }}

        el-card(:body-style='{ padding: "20px" }', shadow='never')
            el-form.col-12(
                label-position='top',
                :model='formCadastroManual',
                :rules='formCadastroManualRegras',
                ref='formCadastroManualRef'
            )
                .row
                    el-form-item.col-3(
                        v-if='isUsuarioLDC',
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                        prop='numeroContrato'
                    )
                        el-input#numeroContrato(
                            v-model='formCadastroManual.numeroContrato',
                            :placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.placeholderValor")'
                        )

                    el-form-item.col-5(
                        v-else,
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.numeroContrato")',
                        prop='numeroContrato'
                    )
                        el-input#numeroContrato(
                            v-model='formCadastroManual.numeroContrato',
                            :placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.placeholderValor")'
                        )

                    el-form-item.col-2(
                        v-if='isUsuarioLDC',
                        label='Trading',
                        prop='subTrading'
                    )
                        el-select#subTrading(
                            v-model='formCadastroManual.subTrading',
                            :loading='loading.subTradings',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.subTradings',
                                :key='id + nome',
                                :id='"subTrading-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.cultura")',
                        prop='cultura'
                    )
                        el-select#cultura(
                            v-model='formCadastroManual.cultura',
                            :loading='loading.culturas',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ nome, id }, index) in opcoes.culturas',
                                :key='id + nome',
                                :id='"cultura-" + index',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.safra")',
                        prop='safra'
                    )
                        el-select#safra(
                            v-model='formCadastroManual.safra',
                            :loading='loading.safras',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='({ ano, id }, index) in opcoes.safras',
                                :key='id + ano',
                                :id='"safra-" + index',
                                :label='ano',
                                :value='id'
                            )

                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.volumeContratado")',
                        prop='volumeContratado'
                    )
                        el-input#volumeContratado(
                            v-model='formCadastroManual.volumeContratado',
                            :placeholder='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.placeholderVolume")'
                        )
                .row
                    el-form-item.col-3(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.formAr.dataContrato")',
                        prop='dataContrato'
                    )
                        el-date-picker#dataContrato(
                            v-model='formCadastroManual.dataContrato',
                            type='date',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            format='dd/MM/yyyy'
                        )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.departamento")',
                        prop='departamento'
                    )
                        el-select#departamento(
                            v-model='formCadastroManual.departamento',
                            :loading='loading.departamentos',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='{ id, nome } in opcoes.departamentos',
                                :key='id',
                                :id='id',
                                :label='nome',
                                :value='id'
                            )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.fornecedor")',
                        prop='fornecedor'
                    )
                        el-select#fornecedor(
                            v-model='formCadastroManual.fornecedor',
                            value-key='id',
                            :loading='loading.fornecedor',
                            @change='definirCnpjFornecedor',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='fornecedor in opcoes.fornecedores',
                                :key='fornecedor.id + fornecedor.nome',
                                :id='"fornecedor-" + fornecedor.id',
                                :label='fornecedor.nome',
                                :value='fornecedor'
                            )

                    el-form-item.col-2(
                        :label='$t("mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.form.ruc")',
                        prop='cnpjFornecedor'
                    )
                        el-select#cnpjFornecedor(
                            v-model='formCadastroManual.cnpjFornecedor',
                            :disabled='!formCadastroManual.fornecedor',
                            :placeholder='$t("mensagens.comuns.selecione")',
                            clearable,
                            filterable
                        )
                            el-option(
                                v-for='(cnpj, index) in opcoes.cnpjFornecedores',
                                :key='cnpj',
                                :id='"cnpjFornecedor-" + index',
                                :label='cnpj',
                                :value='cnpj'
                            )

                    el-form-item.col-3.botao
                        el-button#adicionar(
                            type='primary',
                            :disabled='adicionandoContrato',
                            @click='adicionarPY'
                        )
                            i.el-icon(
                                style='margin-right: 10px; color: #fff !important;',
                                :class='adicionandoContrato ? "el-icon-loading" : "el-icon-plus"'
                            )
                            | {{ $t('mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.adicionarLista') }}
</template>

<script>
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';
import ContratoOriginacaoServiceEmpresa from '@/services/ContratoOriginacaoServiceEmpresa';
import LocalidadeService from '@/services/LocalidadeService';
import { mapGetters } from 'vuex';

export default {
    name: 'EmpresaBlocoInserirContratoOriginacaoManualmente',

    data() {
        const validarVolumeContratado = (rule, value, callback) => {
            if (value === '') {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }

            if (value.toString().includes('.')) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoVolumeContrato'
                        )
                    )
                );
                return;
            }

            const maisVirgulas = /.*,.*,.*/;
            if (
                maisVirgulas.test(value) ||
                value.toString().startsWith(',') ||
                value.toString().endsWith(',')
            ) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroMalFormatado'
                        )
                    )
                );
                return;
            }

            const numeroVirgula = /^[\d,]+$/;
            if (!numeroVirgula.test(value)) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorNaoAceito'
                        )
                    )
                );
                return;
            }

            if (parseFloat(value.toString().replace(',', '.')) <= 0) {
                callback(
                    new Error(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoValorZerado'
                        )
                    )
                );
                return;
            }

            callback();
        };

        const validarSubTrading = (rule, value, callback) => {
            if (this.usuarioLogado?.isLDC && (!value || value === '')) {
                callback(
                    new Error(this.$t('mensagens.comuns.campoObrigatorio'))
                );
                return;
            }
            callback();
        };

        return {
            formCadastroManual: {
                numeroContrato: '',
                subTrading: '',
                cultura: '',
                safra: '',
                volumeContratado: '',
                dataContrato: '',
                fornecedor: null,
                cnpjFornecedor: '',
                departamento: ''
            },

            formCadastroManualRegras: {
                numeroContrato: [
                    {
                        min: 3,
                        max: 30,
                        message: this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContratoPY'
                        ),
                        trigger: 'blur'
                    },
                    {
                        pattern: /^[A-Za-z0-9-]+$/,
                        message: this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoNumeroContratoPadrao'
                        ),
                        trigger: 'blur'
                    }
                ],
                subTrading: [
                    {
                        validator: validarSubTrading,
                        trigger: 'change'
                    }
                ],
                cultura: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                safra: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                volumeContratado: [
                    {
                        required: true,
                        validator: validarVolumeContratado,
                        trigger: 'blur'
                    }
                ],
                dataContrato: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                fornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                cnpjFornecedor: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ],
                departamento: [
                    {
                        required: true,
                        message: this.$t('mensagens.comuns.campoObrigatorio'),
                        trigger: 'change'
                    }
                ]
            },

            opcoes: {
                culturas: [],
                safras: [],
                fornecedores: [],
                cnpjFornecedores: [],
                departamentos: [],
                subTradings: []
            },

            loading: {
                culturas: true,
                safras: true,
                fornecedor: true,
                cnpjFornecedores: true,
                departamentos: true,
                subTradings: true
            },

            adicionandoContrato: false,

            pickerOptionsDataContrato: {
                disabledDate: date => date > new Date()
            }
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado']),
        isUsuarioLDC() {
            return this.usuarioLogado.isLDC;
        }
    },

    mounted() {
        this.buscarCulturas();
        this.buscarSafras();
        this.buscarFornecedores();
        this.buscarDepartamentos();

        if (this.isUsuarioLDC) {
            this.buscarSubTradings();
        }
    },

    methods: {
        async buscarCulturas() {
            try {
                this.loading.culturas = true;
                const { data } = await ContratoOriginacaoService.buscarCulturas();
                this.opcoes.culturas = data;
                this.loading.culturas = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarCultura'
                    )
                );
            }
        },

        async buscarSubTradings() {
            try {
                this.loading.subTradings = true;
                const { data } = await ContratoOriginacaoService.buscarSubTradings();
                this.opcoes.subTradings = data;
                this.loading.subTradings = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSubTrading'
                    )
                );
            }
        },

        async buscarSafras() {
            try {
                this.loading.safras = true;
                const { data } = await ContratoOriginacaoService.buscarSafras();

                this.opcoes.safras = data;
                this.loading.safras = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarSafra'
                    )
                );
            }
        },

        async buscarFornecedores() {
            try {
                this.loading.fornecedor = true;
                const { data } =
                    await ContratoOriginacaoService.buscarBpClientes();

                this.opcoes.fornecedores = data;
                this.loading.fornecedor = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarFornecedor'
                    )
                );
            }
        },

        async buscarDepartamentos() {
            try {
                this.loading.departamentos = true;
                const response =
                    await LocalidadeService.buscarLocalidadeNivelUm();
                const { data } = response;

                this.opcoes.departamentos = data;
                this.loading.departamentos = false;
            } catch (error) {
                this.$notify.error(
                    this.$t(
                        'mensagens.rastreabilidadeEmpresa.contratos.gestaoContratoEmpresa.blocoFiltro.erroBuscarEstados'
                    )
                );
            }
        },

        async definirCnpjFornecedor() {
            this.formCadastroManual.cnpjFornecedor = '';
            this.$refs['formCadastroManualRef'].fields
                .find(f => f.labelFor === 'cnpjFornecedor')
                .resetField();
            if (this.formCadastroManual.fornecedor) {
                this.opcoes.cnpjFornecedores =
                    this.formCadastroManual.fornecedor.cpfCnpj;
            }
        },

        adicionarPY() {
            this.$refs['formCadastroManualRef'].validate(valid => {
                if (valid) {
                    this.adicionandoContrato = true;
                    const payload = {
                        numeroContrato: this.formCadastroManual.numeroContrato,
                        idMaterial: this.formCadastroManual.cultura,
                        idSafra: this.formCadastroManual.safra,
                        volumeContratado: parseFloat(
                            this.formCadastroManual.volumeContratado.replace(
                                ',',
                                '.'
                            )
                        ),
                        dataContrato:
                            this.formCadastroManual.dataContrato.getTime(),
                        idLocalidade: this.formCadastroManual.departamento,
                        idBpCliente: this.formCadastroManual.fornecedor.id,
                        idSubEmpresa:
                            this.formCadastroManual.fornecedor.idEmpresa,
                        ruc: this.formCadastroManual.cnpjFornecedor
                    };

                    if (this.isUsuarioLDC && this.formCadastroManual.subTrading) {
                        payload.idContratoOriginacaoSubTrading = this.formCadastroManual.subTrading;
                    }

                    ContratoOriginacaoServiceEmpresa.cadastrarManualmentePY(payload)
                        .then(() => {
                            this.$notify.success(
                                this.$t(
                                    'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contrato'
                                ) +
                                    ' ' +
                                    this.formCadastroManual.numeroContrato +
                                    ' ' +
                                    this.$t(
                                        'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.contratoInserido'
                                    )
                            );

                            this.$emit('contrato-inserido');
                            this.limpar();
                        })
                        .catch(erro => {
                            this.$notify.error({
                                message: erro.response.data.message
                            });
                        })
                        .finally(() => (this.adicionandoContrato = false));
                } else {
                    this.$notify.warning(
                        this.$t(
                            'mensagens.rastreabilidadeEmpresa.contratos.inserirContratoEmpresa.viaManual.validacaoTodosCampos'
                        )
                    );
                    return false;
                }
            });
        },

        limpar() {
            this.$refs['formCadastroManualRef'].resetFields();
        }
    }
};
</script>

<style lang="scss">
#empresa-bloco-inserir-contrato-originacao-manualmente {
    .el-icon-arrow-right:before {
        content: '\E7A0';
        font-size: 24px;
        padding: 10px;
        color: var(--primary);
    }
    h2.cadastro-contrato-originacao__subtitulo {
        font-size: 16px;
        font-weight: bold;

        margin-bottom: 0px;
        margin-left: 20px;
    }

    .el-card {
        border: none;
    }

    .el-collapse-item {
        border-radius: 10px;
        overflow: hidden;
    }

    .el-collapse-item__content {
        padding: 0px;
    }

    .el-form-item {
        padding: 0 4px;
    }

    .el-select,
    .el-input,
    .el-date-picker,
    .el-button {
        width: 100%;
    }

    .row {
        align-items: flex-end;
        margin-bottom: 15px;
    }

    .el-form-item.is-required:not(.is-no-asterisk)
        > .el-form-item__label::before,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:before {
        content: none !important;
        margin-right: 0px !important;
    }

    .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:after,
    .el-form-item.is-required:not(.is-no-asterisk)
        .el-form-item__label-wrap
        > .el-form-item__label:after {
        content: '*';
        color: #f56c6c;
        margin-left: 4px;
    }
}
</style>
